/**
 * Spolehlivý export PDF — nezávislý na tisku prohlížeče.
 * Vykreslí DOM element do obrázku (html2canvas) a vloží ho jako
 * jednu stránku A4 do PDF (jsPDF). Výsledek je na každém zařízení
 * i prohlížeči stejný a vždy přesně na jedné stránce.
 *
 * Odkazy (<a href>) uvnitř elementu se do PDF přidají jako klikací
 * oblasti přesně nad jejich místem v obrázku — zůstávají funkční.
 *
 * Knihovny se načítají dynamicky — nezvětšují hlavní balík aplikace.
 */

export async function exportElementToPdf(el, fileName = 'export.pdf') {
    if (!el) return;

    const [{ default: html2canvas }, jspdfMod] = await Promise.all([
        import('html2canvas'),
        import('jspdf')
    ]);
    const { jsPDF } = jspdfMod;

    // Vykresli element do canvasu (offscreen prvek html2canvas zvládne).
    const canvas = await html2canvas(el, {
        scale: 2,
        backgroundColor: '#ffffff',
        useCORS: true,
        logging: false
    });

    const doc = new jsPDF({ unit: 'mm', format: 'a4', orientation: 'portrait' });
    const PAGE_W = 210;
    const PAGE_H = 297;
    const MARGIN = 6;
    const availW = PAGE_W - 2 * MARGIN;
    const availH = PAGE_H - 2 * MARGIN;

    // Zmenši obrázek tak, aby se vešel do A4 (zachová poměr stran).
    const ratio = canvas.width / canvas.height;
    let w = availW;
    let h = w / ratio;
    if (h > availH) {
        h = availH;
        w = h * ratio;
    }
    const x = (PAGE_W - w) / 2;
    const y = MARGIN;

    doc.addImage(canvas.toDataURL('image/jpeg', 0.92), 'JPEG', x, y, w, h);

    // Klikací odkazy — přepočítej polohu každého <a href> do souřadnic PDF.
    const elRect = el.getBoundingClientRect();
    if (elRect.width > 0 && elRect.height > 0) {
        el.querySelectorAll('a[href]').forEach((a) => {
            const href = a.getAttribute('href');
            if (!href) return;
            const r = a.getBoundingClientRect();
            if (r.width <= 0 || r.height <= 0) return;
            const lx = x + ((r.left - elRect.left) / elRect.width) * w;
            const ly = y + ((r.top - elRect.top) / elRect.height) * h;
            const lw = (r.width / elRect.width) * w;
            const lh = (r.height / elRect.height) * h;
            doc.link(lx, ly, lw, lh, { url: href });
        });
    }

    doc.save(fileName);
}
